"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var Button_1 = require("../Button");
var ElementWithNote_1 = require("../Internal/ElementWithNote");
var propTypes = {
    text: PropTypes.string.isRequired,
    subText: PropTypes.string,
    note: PropTypes.string,
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    variant: Button_1.buttonPropTypes.variant,
    loading: Button_1.buttonPropTypes.loading
};
/**
 * The `StepButton` extends the ordinary `Button` by also showing a number which
 * indicates a sequence of steps. It is used if a static sequence of steps is given,
 * which has to be executed by the user in the correct order.
 */
var StepButton = /** @class */ (function (_super) {
    __extends(StepButton, _super);
    function StepButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepButton.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, iconLeft = _a.iconLeft, iconRight = _a.iconRight, note = _a.note, step = _a.step, subText = _a.subText, text = _a.text, other = __rest(_a, ["children", "className", "iconLeft", "iconRight", "note", "step", "subText", "text"]);
        var componentClassName = classNames(className, 'ee_step-button');
        // The inner span of the button is needed for styling purposes. Since we use
        // flexbox to style the button, we need a wrapper to treat the children as
        // one element
        return (React.createElement(ElementWithNote_1.ElementWithNote, { note: note, className: componentClassName },
            React.createElement("div", { className: "ee_step-button__button-wrapper" },
                React.createElement(Button_1.Button, __assign({}, other, { className: "ee_step-button__button", "data-step": step }),
                    React.createElement("span", null,
                        React.createElement("span", { className: "ee_step-button__text" }, text),
                        subText && (React.createElement("span", { className: "ee_step-button__sub-text" }, subText)))),
                React.createElement("div", { className: "ee_step-button__decor" }))));
    };
    StepButton.propTypes = propTypes;
    StepButton.defaultProps = {
        text: '',
        subText: undefined,
        note: undefined,
        step: 1,
        variant: undefined,
        loading: false
    };
    return StepButton;
}(react_1.Component));
exports.StepButton = StepButton;
exports.default = StepButton;
//# sourceMappingURL=StepButton.js.map
